import sectionsRef from "@models/interactions/sections-ref";
import LegalLayout from "@components/templates/legal-layout";


export default function CopyrightPolicy() {
  const { model, operations } = sectionsRef();

  return (
    <LegalLayout>
      <main className="w-full flex flex-col text-white px-4 max-w-[900px] mt-[60px] pb-5">
        <h2 className="text-4xl text-center">Copyright Policy</h2>
        <span className="text-center">DMCA COPYRIGHT INFRINGEMENT POLICY</span>
        <article className="flex w-full flex-col justify-start gap-[18px] lg:w-[916px] text-white mt-4">
          <section ref={model.refs[0]} className="flex flex-col gap-5 ">
            <p>
              At Memo’d, we respect the intellectual property rights of others.
              We expect our users to act in a way that does not infringe on others’ rights,
              including ensuring that they do not violate anyone else’s intellectual property rights.
            </p>
          </section>
          <section ref={model.refs[1]} className="flex flex-col gap-5 ">
              <span className="flex flex-col gap-[18px]">
                <strong>DMCA Notice of Alleged Infringement:</strong>
                <p>Memo’d operates it platforms in accordance with the Digital Millennium Copyright Act of 1998 (“DMCA”). 
                  If you are a copyright owner, or authorized to act on behalf of a copyright owner, you may report claims
                  of copyright infringement to us by sending a DMCA Notice of Alleged Infringement (“Notice”) containing the
                  following:
                </p>
                <span className="flex flex-col gap-4 ml-3">
                  <p>1. Identification, including a description, of the copyrighted work you are claiming has been infringed. If multiple copyrighted works are covered by your Notice, you may provide a representative list of the copyrighted works you are claiming have been infringed.</p>
                  <p>2. The location of the allegedly infringing material, including the URL (if applicable) where the allegedly infringing material is accessible or the exact location where the infringing material can be found.</p>
                  <p>3. Your company affiliation (if applicable), mailing address, telephone number, and email address.</p>
                  <span className="flex flex-col">
                    <p>4. Include both of the following statements:</p>
                    <p className="ml-5">a.“I hereby state that I have a good-faith belief that the disputed use of the copyrighted material is not authorized by the copyright owner or other intellectual property rights owner, by its agent, or by law (e.g., as fair use).”</p>
                    <p className="ml-5">b. “I hereby state, under penalty of perjury, that the information in this Notice is accurate and that I am the owner, or am authorized to act on behalf of the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.”</p>
                  </span>
                  
                  <p>5. Your full legal name and your electronic or physical signature.</p>
                </span>
                <p>Send the completed Notice to our DMCA Registered Agent at:</p>

                <span>
                  <p>Attn: Copyright Agent   </p>
                  <p>Memo’d Technologies, LLC</p>
                  <p>12333 Sowden Rd, Ste B c/o PMB 39984</p>
                  <p>Houston, Texas 77080 </p>
                  <a href="mailto:copyright@memod.com" className="text-blue-700 hover:underline">
                    copyright@memod.com
                  </a>
                </span>
                <p>Upon receipt of your Notice, Memo’d will take any and all actions, in our sole discretion and as we deem appropriate, including removing the challenged material or disabling access to the challenged material. Please note that you must comply with all of the requirements of this policy and of 17 USC § 512(c)(3) for your Notice to be valid.</p>
              </span>
          </section>
          <section ref={model.refs[2]} className="flex flex-col gap-5 ">
           <span className="flex flex-col gap-[18px]">
              <strong>DMCA Counter-Notice of Alleged Infringement:</strong>
              <p>If you believe that we have removed or disabled content that is not infringing,
                 or that you otherwise have authorization from the copyright holder to lawfully 
                 use in your content, you may send Our DMCA Registered Agent (at the contact 
                 information provided above) a Counter-Notice (“Counter-Notice”) containing the 
                 following information:
              </p>
              <div className="ml-3 flex flex-col gap-[18px]">
                <p>1. Your full legal name, address, telephone number, email address,
                  and your physical or electronic signature.
                </p>
                <p>2. Identification of the content which you believe was mistakenly removed or to which
                   access was mistakenly disabled, as well as the location where it appeared.
                </p>
                <p>3. An acknowledgment that you have reviewed our copyright infringement policy.
                </p>
                <span>
                  <p>4. Include both of the following statements:</p>
                  <p className="ml-3">a. “I hereby state, under penalty of perjury, that I have a good-faith belief that the material was removed or disabled as a result of a mistake or misidentification of the content.”</p>
                  <p className="ml-3">b. “I hereby state that I consent to the jurisdiction of a U.S. Federal Court for any judicial district in which Memo’d may be found, and that I will accept service of process from the person who provided notification of the alleged infringement.”</p>
                </span>
              </div>

           </span>
          </section>
          <section ref={model.refs[3]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <p>If a valid Counter-Notice is received by our DMCA Copyright Agent,
                 Memo’d may send a copy of the Counter-Notice to the original complaining party
                 informing that party that we may replace the removed content or cease disabling it.
                 If the copyright owner disagrees that the content was removed in error or misidentification,
                 they may pursue legal action against you.  If we do not receive notice within 10 business days
                 that the original complaining party is seeking a court order to prevent further infringement of
                 the material at issue, we may replace or cease disabling access to the material that was removed.
              </p>
              <p>
                 MEMO’D IN NO WAY WAIVES ANY RIGHT TO PURSUE ANY AVAILABLE REMEDY AT LAW OR IN EQUITY AGAINST COPYRIGHT
                 INFRINGERS OR ANY OTHER INTELLECTUAL PROPERTY RIGHTS VIOLATORS, NOR WILL MEMO’D INDEMNIFY OR PROVIDE 
                 LEGAL REPRESENTATION TO ANY ALLEGED INFRINGER IN ANY ACTION ARISING FROM THE ALLEGED INFRINGER’S USE 
                 OF ANY MEMO’D WEBSITE OR SERVICE.
              </p>
            </span>
          </section>
        </article>

      </main>
    </LegalLayout>
  );
}
